/**
 * Krümel-Zeilen für den Abschlussbildschirm.
 *
 * Ton: Die Welt meint es ernst, die Ränder grinsen (Game-Design §2.4).
 * Der Krümel kommentiert trocken und buchhalterisch. Kein Meta-Witz, keine
 * Popkultur, keine Ausrufezeichen, kein Anstupsen.
 *
 * Diese Zeilen sind von Hand geschrieben und dienen zugleich als Muster für
 * die spätere Textbank (docs/design/lokale-ki.md §2): Ein Modell bekommt
 * diese hier als Beispiel und schreibt in derselben Tonlage weiter.
 */

export const KRUEMEL_ZEILEN = {
  geschafft: [
    'Zurück. Ich habe die Ausgaben notiert. Wir sprechen später darüber.',
    'Der Korb war voll, der Weg war lang. Beides ist verbucht.',
    'Angemessener Ertrag. Ich habe schon Schlimmeres in dieses Buch geschrieben.',
    'Ich führe das unter „gelungen", solange niemand die Rückseite liest.',
    'Zwei Fladen verbraucht, ein Hammer stumpf. Unterm Strich ein Gewinn.',
    'Die Zunft wird zufrieden sein. Ich bin es zurückhaltend.',
    'Das war ordentlich. Sag das nicht weiter, ich muss noch verhandeln.',
  ],
  gescheitert: [
    'Ich habe den Korb hochgetragen. Dich leider nicht.',
    'Buchhalterisch ein Totalverlust. Persönlich bedaure ich es.',
    'Die Zunft ersetzt den Fladen. Den Rest musst du selbst regeln.',
    'Ich habe vermerkt, wo es passiert ist. Für das nächste Mal.',
    'Es ist nicht meine Aufgabe, dich zu warnen. Ich hätte es trotzdem tun sollen.',
    'Kein Ertrag, keine Beschwerde. Nur eine Zeile im Buch.',
    'Ich habe die Stelle markiert. Sie ist gut zu finden.',
  ],
} as const;

/**
 * Wählt eine Zeile deterministisch aus einer Kennzahl — kein Math.random,
 * damit derselbe Abstieg auch dieselbe Zeile bekommt.
 */
export function waehleZeile(zeilen: readonly string[], kennzahl: number): string {
  const i = Math.abs(Math.round(kennzahl)) % zeilen.length;
  return zeilen[i] as string;
}
